import React from 'react';
import { UserCheck } from 'lucide-react';

export const TechnicianPicker = ({ staff, value, onChange, disabled }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  if (!staff.length) {
    return <p className="text-xs text-slate-500" data-testid="jc-tech-empty">No active staff yet. Add them under Staff Master.</p>;
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid="jc-tech-picker">
      {staff.map((s) => {
        const on = value.includes(s.id);
        return (
          <button
            key={s.id}
            type="button"
            disabled={disabled}
            onClick={() => toggle(s.id)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${on ? 'border-teal-600 bg-teal-50 text-teal-800' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'}`}
            data-testid={`jc-tech-${s.id}`}
          >
            {on && <UserCheck size={12} />}
            {s.name}
          </button>
        );
      })}
    </div>
  );
};

export default TechnicianPicker;
